<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />

      <v-skeleton-loader
        type="chip"
        transition="fade-transition"
        v-if="loading"
      ></v-skeleton-loader>
      <v-toolbar-title v-else class="headline font-weight-bold"
        >Reported Users ({{
          listMeta.total ? listMeta.total : 0
        }})</v-toolbar-title
      >

      <v-spacer></v-spacer>
      <v-row v-show="showSearch" align="center" style="max-width: 300px;">
        <v-text-field
          class="search"
          ref="searchField"
          flat
          hide-details
          solo
          rounded
          clearable
          background-color="grey lighten-3"
          label="Search name"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>

      <v-btn class="ml-5" icon @click="showSearchField">
        <img src="@/assets/icons/search.svg" alt height="17.7px" />
      </v-btn>
    </v-app-bar>

    <div
      class="mt-12 mx-4"
      id="report-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="100"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th width="15%" class="text-left pa-0">Reported</th>
            <th width="15%" class="text-left">Reporter</th>
            <th width="20%" class="text-left">Reason</th>
            <th width="30%" class="text-left">Description</th>
            <th width="15%" class="text-left">Added date</th>
            <th width="5%" class="text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="report in reports"
            :key="report.id"
            class="clickable"
            @click="
              $router.push({
                name: 'user.reports-details',
                params: { id: report.id }
              })
            "
          >
            <td>
              {{ report.reportable.full_name }}
            </td>
            <td>
              {{ report.reporter.full_name }}
            </td>
            <td>{{ report.reason.label }}</td>
            <td>{{ report.description }}</td>
            <td>{{ report.addedDate }}</td>
            <td style="cursor: pointer;">view details</td>
          </tr>

          <SkeletonLoader
            v-show="loading"
            v-for="index in 10"
            :key="index + '-skeleton'"
          ></SkeletonLoader>
        </tbody>
      </v-simple-table>
      <div
        class="d-flex justify-center mt-3"
        v-if="!(reports.length > 0) && !loading"
      >
        <p>No match found.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  mdiDotsVertical,
  mdiUnfoldMoreHorizontal,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiChevronRight,
  mdiFileExcel
} from '@mdi/js'
import infiniteScroll from 'vue-infinite-scroll'
import debounce from 'lodash/debounce'
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import SkeletonLoader from '@/components/Report/list/SkeletonLoader'

export default {
  name: 'UserReportsPage',

  mixins: [ControlsMixin],

  directives: {
    infiniteScroll
  },

  components: {
    AppBarNavIcon,
    SkeletonLoader
  },

  data() {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: ''
      },
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight,
        export: mdiFileExcel
      }
    }
  },

  created() {
    this.clearReport()
    this.fetchReports(1)
  },

  computed: {
    ...mapState({
      reports: state => state.userReport.list,
      listMeta: state => state.userReport.listMeta
    }),

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    ...mapActions({
      getReports: 'userReport/getReports'
    }),

    ...mapMutations({
      clearReport: 'userReport/clearReportsList'
    }),

    pageChanged(page) {
      this.fetchReports(page)
    },

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchReports(this.listMeta.current_page + 1)
      }
    },

    search: debounce(function() {
      this.clearReport()
      this.fetchReports()
    }, 600),

    async fetchReports(page = 1) {
      if (this.loading) return
      let params = { page }

      if (this.filter.search) {
        params.search = this.filter.search
      }
      params.reportable_type = 'user'

      this.loading = true
      await this.getReports(params)
      this.loading = false
    },
    async showSearchField() {
      this.showSearch = !this.showSearch
      await this.$nextTick()
      this.$refs.searchField.$refs.input.focus()
    }
  }
}
</script>
